import React from "react";

const RespondedChat = () => {
  return <div>Chat</div>;
};

export default RespondedChat;
